var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDockerExtensionMeshery = function SvgDockerExtensionMeshery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "docker-extension-meshery_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 362.7 393.9"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".docker-extension-meshery_svg__st0{fill:#18272f}.docker-extension-meshery_svg__st1{fill:#e8e8ee}.docker-extension-meshery_svg__st2{fill:#00b29e}.docker-extension-meshery_svg__st3{fill:#2c3476}.docker-extension-meshery_svg__st4{fill:#4abea0}.docker-extension-meshery_svg__st5{fill:#03b29f}.docker-extension-meshery_svg__st6{fill:none;stroke:#18272f;stroke-width:3.5;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.3 359.8c-11.4-10.4-25.2-29-31.9-42.3-3.1-6.1-3.7-13-5.4-19.5-3.4-12.5-5-25.4-6.6-38.2-.3-2.2-.5-4-3.3-3.7 3.2-2.4 4.3-.4 4.7 2.4 1.9 11.3 4.5 22.3 7.3 33.4 9.2 36.4 29.6 64.3 63.4 81.7 17.9 9 36.8 14.2 56.7 15.4 33.8 2 65.4-6.2 95.2-21.7 7.2-3.7 14.3-7.5 21.4-11.2 18.9-11 4.6 4-24.3 17.7-28.5 14.3-58.8 21.9-90.9 20-32.3-2-61.6-12.3-86.3-34",
    className: "docker-extension-meshery_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.3 342.9c-.8.1 4.3-.7 2.9 1.8-3.9 7.1-13 16.7-14.4 11.2-.7-.5 9.3-9.8 9-9l.1-.1c-2 0-3.4 1.2-5 2-6.2 3.1-12.6 6-19.3 7.9-27.6 7.7-53.8 2.9-78.8-9.8-12.3-6.2-22.1-15.1-27.1-28.5-.1-.8-.1-1.6-.3-2.4-.9-4.5.2-8.4 4.1-10.9 3.7-2.4 7.1-.3 10 2 3 2.4 5.8 5 8.5 7.7 17.9 17.7 39.1 27.9 64.7 26.7 18.4-.8 35.8-6 52.7-13.2 3.6-1.5 6.6-3.8 8.7-7.2 13.1-21.3 22.2-44.1 24.4-69.1 3-32.8-7.6-61.2-29.4-85.9-7.1-8-14.5-9.8-24.6-6.7-25.3 7.6-49.6 17.7-72.9 30-30.4 16-60.1 33.1-91 48.1-17.6 8.5-36.3 11.3-55.7 6.8-6.7-1.6-6.9-1.8-5.3-8.8 4.7-21-1.8-38.5-16.3-53.7-2.3-2.4-3.3-2.5-5.3.5-9.8 15-15 30.2-3.3 46.9-5.6-4.3-11.8-7-18.1-9.6-8.9-3.6-17.5-2.4-26 1.4-3 1.4-4.1 2.9-2.4 6.1 4.4 7.9 9.3 15.4 16.7 20.8 9.9 7.3 20.9 10.4 33.1 8.1-5.8 3.6-12.2 3.6-18.5 2.5-15.1-2.6-25.1-12.2-32.8-24.6-2.1-3.4-3.9-6.9-5.8-10.4.3-1.8 1.8-2.3 3.1-2.9 4.3-2.5 8.5-5.4 13.4-6.5.5 0 .9-.1 1.4-.1 9.9-2.6 18.6.5 27 5.4.2.1.4.3.7.4v-1c-4.4-12.8-1-24.1 6.2-34.8.4-.5.8-1.1 1.2-1.6 5.4-5.9 6.9-5.8 12.6-.3 6.6 6.4 12.5 13.3 15.6 22.1 3.9 11 4.4 22.1-.2 33-1.7 4.1.2 5.1 3.4 5.6 6.9 1.1 16.1 1 23 .1 1.9-.3 11.9-.8 24.2-7.1 46.7-23.8 150-74.1 150-74.1s18.2-6.2 27.7-8c4-.8 7.4-.2 10.8 2.2 33 24 45.1 57.2 42.2 96.7-1.7 23.4-10.3 44.7-21.5 65.1-4 7.2-11.2 10.8-18.3 14-5.4 2.5-11.1 4.3-16.8 6.5 2.6 3.4 5.1 6.2 8.7 5.4M192.2 204.7c1.1-.5 2.7-.8 4.1-2.1m-50 26 69.6-36.6c18.2-10.1 65.7-30.4 65.7-30.4m-73.3 34.1",
    className: "docker-extension-meshery_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.7 318.4c4.9 13.4 14.8 22.3 27.1 28.5 25 12.7 51.2 17.5 78.8 9.8 6.7-1.9 13-4.7 19.3-7.9 1.6-.8 3-2.1 5-2 3.1 1.2-5.5 6.4-9 9.1-7.1 3.7-14.3 7.5-21.4 11.2-29.9 15.5-61.4 23.7-95.2 21.7-19.9-1.2-38.9-6.4-56.7-15.4.9-1.7 2.7-1.7 4.2-2.2 24.5-7.5 40.9-22.6 46-48.5.2-1.6.5-3.2 1.9-4.3",
    className: "docker-extension-meshery_svg__st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.7 318.4c-1.4 1.1-1.8 2.7-2.1 4.4-5 25.9-21.5 41-46 48.5-1.6.5-3.3.4-4.2 2.2-33.8-17.4-54.1-45.2-63.4-81.7-2.8-11.1-5.4-22.1-7.3-33.4-.5-2.8-1.5-4.8-4.7-2.4-12.3 2.2-23.3-.8-33.1-8.1-7.4-5.5-12.3-12.9-16.7-20.8-1.7-3.1-.7-4.7 2.4-6.1 8.5-3.8 17.1-5 26-1.4 6.3 2.5 12.5 5.3 18.1 9.6-11.7-16.7-6.5-31.9 3.3-46.9 2-3 3-2.9 5.3-.5 14.5 15.2 20.9 32.7 16.3 53.7-1.5 7-1.4 7.2 5.3 8.8 19.4 4.6 38.1 1.7 55.7-6.8 30.9-15 60.7-32.1 91-48.1q34.95-18.45 72.9-30c10.1-3 17.5-1.3 24.6 6.7 21.8 24.6 32.4 53 29.4 85.9-2.2 25-11.4 47.8-24.4 69.1-2.1 3.4-5.2 5.7-8.7 7.2-16.9 7.2-34.3 12.4-52.7 13.2-25.6 1.2-46.8-8.9-64.7-26.7-2.7-2.7-5.5-5.3-8.5-7.7-2.9-2.3-6.3-4.4-10-2-3.9 2.5-5 6.4-4.1 10.9.2.7.2 1.6.3 2.4m-29.8-63.7c-.7.7-1.4 1.3-2.1 2-3.7 5.3-6 11.1-4 17.6 4 12.8 15.8 17 28.8 10.6 15-7.4 18.1-25.2 6.3-35.6-9.2-8.1-25.4-5-29 5.4",
    className: "docker-extension-meshery_svg__st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6 218.7v1c-.2-.1-.4-.3-.7-.4.2-.2.4-.4.7-.6",
    className: "docker-extension-meshery_svg__st3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.8 256.7c.7-.7 1.4-1.3 2.1-2 2 2 .8 6 4.4 7 4.7 1.3 8.8 0 12.4-2.9 3.2-2.6 5.4-5.8 3.7-10.3.3-.2.5-.5.8-.7 8.2 2.9 12.9 10.4 11.6 18.4-1.3 8.4-9.5 16.4-17.9 17.8-6.5 1.1-12.3 0-16.5-5.4-4.2-5.3-4.3-11.2-1.9-17.4.5-1.4 1.9-2.7 1.3-4.5",
    className: "docker-extension-meshery_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.5 248.5c1.7 4.5-.5 7.7-3.7 10.3-3.6 3-7.7 4.2-12.4 2.9-3.6-1-2.4-5-4.4-7 3.6-10.4 19.8-13.4 29-5.4 11.9 10.4 8.7 28.3-6.3 35.6-13 6.4-24.8 2.2-28.8-10.6-2-6.5.2-12.3 4-17.6.6 1.8-.8 3.1-1.4 4.6-2.4 6.2-2.2 12.1 1.9 17.4 4.2 5.4 10 6.5 16.5 5.4 8.5-1.5 16.6-9.4 17.9-17.8 1.3-8-3.4-15.5-11.6-18.4-.4-.1-.7-.3-1.1-.4.1.2.3.6.4 1",
    className: "docker-extension-meshery_svg__st0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.5 248.5c-.1-.4-.2-.8-.4-1.2.4.1.7.3 1.1.4-.2.3-.5.5-.7.8",
    className: "docker-extension-meshery_svg__st1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.6 137.3v26.1l22.6-13.1zM149.6 168.8V195l22.8-13.1z",
    className: "docker-extension-meshery_svg__st4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4 163.2v-25.7l-22.3 12.8zM101.7 194.9c4.4 7 10.3 13 17.3 17.4v-27.4zM146.4 194.9V169L124 181.9z",
    className: "docker-extension-meshery_svg__st5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m122.2 210.7 22.7-13-22.7-13.1z",
    className: "docker-extension-meshery_svg__st4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174 210.8v-26l-22.6 12.9zM196.1 191.9c3.8-7 6-14.9 6.4-23.4L179 182z",
    className: "docker-extension-meshery_svg__st5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m177.2 179.2 22.7-13-22.7-13z",
    className: "docker-extension-meshery_svg__st4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174 147.5v-25.8l-22.5 12.9zM174 179.1V153l-22.6 13.1zM148 220.7",
    className: "docker-extension-meshery_svg__st5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.2 153v26.2l22.7-13.1z",
    className: "docker-extension-meshery_svg__st4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4 111.6c-8.6.3-16.8 2.5-23.9 6.3l23.9 13.8z",
    className: "docker-extension-meshery_svg__st5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.2 121.5v26.1l22.8-13z",
    className: "docker-extension-meshery_svg__st4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119 120c-7 4.4-12.9 10.4-17.3 17.4l17.3 10z",
    className: "docker-extension-meshery_svg__st5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M173.8 118.1c-7.2-3.9-15.4-6.2-24.2-6.5v20.3zM93.5 168c.3 8.7 2.6 16.8 6.5 24l17.5-10.1zM100 140.2c-3.9 7.2-6.2 15.3-6.5 23.9l24.1-13.8z",
    className: "docker-extension-meshery_svg__st4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M122.4 214.3c7.2 3.8 15.3 6.1 24 6.4v-20.1z",
    className: "docker-extension-meshery_svg__st5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.4 137.4c-4.3-7-10.2-13-17.2-17.4v27.3zM177.2 212.2c7-4.4 12.9-10.4 17.3-17.5l-17.3-10z",
    className: "docker-extension-meshery_svg__st4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.5 164c-.3-8.6-2.6-16.6-6.5-23.7l-17.3 10z",
    className: "docker-extension-meshery_svg__st5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M149.6 220.6c8.6-.3 16.8-2.5 23.9-6.3l-23.9-13.8z",
    className: "docker-extension-meshery_svg__st4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119 179v-25.7l-22.4 12.8z",
    className: "docker-extension-meshery_svg__st5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M248.7 88.4v26.1l22.6-13.1zM248.7 119.9v26.2l22.8-13z",
    className: "docker-extension-meshery_svg__st4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 114.3V88.6l-22.3 12.8zM200.8 146c4.4 7 10.3 13 17.3 17.4V136zM245.5 146v-25.9l-22.4 13z",
    className: "docker-extension-meshery_svg__st5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m221.3 161.8 22.6-13-22.6-13.1z",
    className: "docker-extension-meshery_svg__st4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M273.1 161.9v-26l-22.6 12.9zM295.2 143c3.8-7 6-14.9 6.4-23.4L278 133.1z",
    className: "docker-extension-meshery_svg__st5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m276.3 130.3 22.7-13-22.7-13z",
    className: "docker-extension-meshery_svg__st4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M273.1 98.7V72.8l-22.5 12.9zM273.1 130.2v-26.1l-22.6 13.1zM247.1 171.8",
    className: "docker-extension-meshery_svg__st5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M221.3 104.1v26.3l22.7-13.2z",
    className: "docker-extension-meshery_svg__st4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 62.7c-8.6.3-16.8 2.5-23.9 6.3l23.9 13.8z",
    className: "docker-extension-meshery_svg__st5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M221.3 72.7v26.1L244 85.7z",
    className: "docker-extension-meshery_svg__st4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M218 71.1c-7 4.4-12.9 10.4-17.3 17.4l17.3 10z",
    className: "docker-extension-meshery_svg__st5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M272.9 69.2c-7.2-3.9-15.4-6.2-24.2-6.5V83zM192.6 119.2c.3 8.7 2.6 16.8 6.5 24l17.5-10.1zM199.1 91.3c-3.9 7.2-6.2 15.3-6.5 23.9l24.1-13.8z",
    className: "docker-extension-meshery_svg__st4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 165.4c7.2 3.8 15.3 6.1 24 6.4v-20.1z",
    className: "docker-extension-meshery_svg__st5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M293.5 88.6c-4.3-7-10.2-13-17.2-17.4v27.3zM276.3 163.3c7-4.4 12.9-10.4 17.3-17.5l-17.3-10z",
    className: "docker-extension-meshery_svg__st4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M301.6 115.1c-.3-8.6-2.6-16.6-6.5-23.7l-17.3 10z",
    className: "docker-extension-meshery_svg__st5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M248.7 171.8c8.6-.3 16.8-2.5 23.9-6.3l-23.9-13.8z",
    className: "docker-extension-meshery_svg__st4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M218 130.1v-25.7l-22.3 12.8z",
    className: "docker-extension-meshery_svg__st5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M157.3 27.5v26l22.5-13zM157.3 59v26.2L180 72.1z",
    className: "docker-extension-meshery_svg__st4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M154 53.4V27.7l-22.3 12.8zM109.3 85.1c4.4 7 10.3 13 17.3 17.4V75.1zM154 85V59.2l-22.3 12.9z",
    className: "docker-extension-meshery_svg__st5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m129.8 100.8 22.7-12.9-22.7-13.1z",
    className: "docker-extension-meshery_svg__st4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 101V75L159 87.9zM203.7 82.1c3.8-7 6-14.9 6.4-23.4l-23.6 13.5z",
    className: "docker-extension-meshery_svg__st5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m184.8 69.4 22.8-13-22.8-13z",
    className: "docker-extension-meshery_svg__st4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 37.7V11.9l-22.5 12.9zM181.6 69.3V43.2L159 56.3zM155.6 110.9",
    className: "docker-extension-meshery_svg__st5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M129.8 43.2v26.2l22.8-13.1z",
    className: "docker-extension-meshery_svg__st4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154 1.8c-8.6.3-16.8 2.5-23.9 6.3L154 21.9z",
    className: "docker-extension-meshery_svg__st5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M129.8 11.7v26.1l22.8-13z",
    className: "docker-extension-meshery_svg__st4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M126.6 10.1c-7 4.4-12.9 10.4-17.3 17.4l17.3 10z",
    className: "docker-extension-meshery_svg__st5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M181.4 8.3c-7.2-3.9-15.4-6.2-24.2-6.5v20.3zM101.1 58.2c.3 8.7 2.6 16.8 6.5 24l17.5-10.1zM107.7 30.4c-3.9 7.2-6.2 15.3-6.5 23.9l24.1-13.8z",
    className: "docker-extension-meshery_svg__st4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M130 104.5c7.2 3.8 15.3 6.1 24 6.4V90.8z",
    className: "docker-extension-meshery_svg__st5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M202 27.6c-4.3-7-10.2-13-17.2-17.4v27.3zM184.8 102.4c7-4.4 12.9-10.4 17.3-17.5l-17.3-10z",
    className: "docker-extension-meshery_svg__st4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M210.1 54.1c-.3-8.6-2.6-16.6-6.5-23.7l-17.3 10z",
    className: "docker-extension-meshery_svg__st5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M157.3 110.8c8.6-.3 16.8-2.5 23.9-6.3l-23.9-13.8z",
    className: "docker-extension-meshery_svg__st4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M126.6 69.2V43.4l-22.4 12.9z",
    className: "docker-extension-meshery_svg__st5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.6,
    cy: 56.2,
    r: 54.5,
    className: "docker-extension-meshery_svg__st6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 166.2,
    r: 54.5,
    className: "docker-extension-meshery_svg__st6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.1,
    cy: 117.2,
    r: 54.5,
    className: "docker-extension-meshery_svg__st6"
  })));
};
export { SvgDockerExtensionMeshery as ReactComponent };
export default __webpack_public_path__ + "static/docker-extension-meshery.48c50525.svg";